import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 유형 1 - 심플 타이틀 (좌우 이미지 없음, 깔끔한 디자인)
 * 원본: banner-simple fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} subtitle - 서브타이틀
 */
const BannerSimple = ({ title, breadcrumbPath, subtitle = '' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const menuPath = getMenuPath(breadcrumbPath);
  const hasSubtitle = subtitle && subtitle.trim() !== '';

  return (
    <>
      <style>
        {`
          .banner-simple {
            background: linear-gradient(135deg, #ffffff 0%, var(--theme-color-secondary) 50%, #19516b 100%);
            background-size: 200% 200%;
            animation: gradientShift 8s ease infinite;
            padding: 60px 0px;
            color: white;
            text-align: center;
            position: relative;
            overflow: hidden;
          }
          .banner-simple::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%),
                        radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%);
            pointer-events: none;
          }
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .banner-simple .container {
            position: relative;
            z-index: 1;
          }
          .banner-simple .banner-title {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 15px;
            text-shadow: 2px 2px 8px rgba(0,0,0,0.3);
            letter-spacing: -0.5px;
          }
          .banner-simple .banner-subtitle {
            font-size: 1.1rem;
            opacity: 0.95;
            margin-bottom: 20px;
            font-weight: 300;
            letter-spacing: 0.5px;
          }
          .banner-simple .banner-breadcrumb {
            font-size: 0.95rem;
            opacity: 0.9;
            display: inline-block;
            padding: 8px 18px;
            background: rgba(255,255,255,0.15);
            backdrop-filter: blur(10px);
            border-radius: 20px;
            border: 1px solid rgba(255,255,255,0.2);
          }
          .banner-simple .banner-breadcrumb a {
            color: white;
            text-decoration: none;
            transition: opacity 0.3s ease;
          }
          .banner-simple .banner-breadcrumb a:hover {
            opacity: 0.8;
            text-decoration: underline;
          }
        `}
      </style>
      <div className="banner-simple">
        <div className="container">
          <h1 className="banner-title" data-aos="fade-down" data-aos-delay="100">
            {escapeHtml(pageTitle)}
          </h1>
          {hasSubtitle && (
            <p className="banner-subtitle">{escapeHtml(subtitle)}</p>
          )}
          <div className="banner-breadcrumb" data-aos="fade-up" data-aos-delay="100">
            {menuPath}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerSimple;

